
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/docs/concepts/car-files",
      function () {
        return require("private-next-pages/docs/concepts/car-files.md");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/docs/concepts/car-files"])
      });
    }
  